<template>
  <div class="container-fluid p-4 shadow-sm rounded">

    <!-- ENCABEZADO -->
    <div class="card mb-4">
      <div class="card-header bg-success text-white fw-bold py-1 d-flex justify-content-between align-items-center">
        <span>Guía de Remisión</span>
        <span v-if="secuencial" class="small fw-normal">{{ secuencial }}</span>
      </div>
      <div class="card-body py-2">
        <div class="row gy-2">
          <div class="col-md-3">
            <label class="form-label small mb-1">Fecha Emisión</label>
            <input type="date" class="form-control form-control-sm" v-model="cabecera.fechaEmision" />
          </div>
          <div class="col-md-3">
            <label class="form-label small mb-1">Punto Emisión</label>
            <select class="form-select form-select-sm" v-model="cabecera.puntoEmisionId" :disabled="cargandoPuntos">
              <option v-if="cargandoPuntos" disabled value="">Cargando...</option>
              <option v-else-if="puntosEmision.length === 0" disabled value="">Sin puntos</option>
              <option v-for="p in puntosEmision" :key="p.id" :value="p.id">{{ p.full_code }}</option>
            </select>
          </div>
          <div class="col-md-3">
            <label class="form-label small mb-1">Ambiente</label>
            <input type="text" class="form-control form-control-sm" v-model="cabecera.ambiente" disabled />
          </div>
          <div class="col-md-3">
            <label class="form-label small mb-1">Secuencial</label>
            <input type="text" class="form-control form-control-sm" v-model="secuencial" disabled />
          </div>
        </div>
      </div>
    </div>

    <!-- TRANSPORTISTA -->
    <div class="card mb-4">
      <div class="card-header bg-success text-white fw-bold py-1">Transportista</div>
      <div class="card-body py-2">
        <div class="row gy-2">
          <div class="col-md-4">
            <label class="form-label small mb-1">RUC Transportista</label>
            <div class="input-group input-group-sm">
              <input
                type="text"
                class="form-control form-control-sm"
                placeholder="RUC del transportista"
                v-model="transportista.ruc"
                @blur="buscarTransportista"
                @keyup.enter="buscarTransportista"
              />
              <span v-if="buscandoTransportista" class="input-group-text">
                <span class="spinner-border spinner-border-sm"></span>
              </span>
            </div>
          </div>
          <div class="col-md-5">
            <label class="form-label small mb-1">Razón Social</label>
            <input type="text" class="form-control form-control-sm" v-model="transportista.razonSocial" placeholder="Razón social del transportista" />
          </div>
          <div class="col-md-3">
            <label class="form-label small mb-1">Placa del Vehículo</label>
            <input type="text" class="form-control form-control-sm" v-model="transportista.placa" placeholder="Ej: ABC-1234" maxlength="10" />
          </div>
        </div>
      </div>
    </div>

    <!-- DATOS DEL TRASLADO -->
    <div class="card mb-4">
      <div class="card-header bg-success text-white fw-bold py-1">Datos del Traslado</div>
      <div class="card-body py-2">
        <div class="row gy-2">
          <div class="col-md-3">
            <label class="form-label small mb-1">Fecha Inicio Transporte</label>
            <input type="date" class="form-control form-control-sm" v-model="traslado.fechaInicio" />
          </div>
          <div class="col-md-3">
            <label class="form-label small mb-1">Fecha Fin Transporte</label>
            <input type="date" class="form-control form-control-sm" v-model="traslado.fechaFin" />
          </div>
          <div class="col-md-6">
            <label class="form-label small mb-1">Dirección de Partida</label>
            <input type="text" class="form-control form-control-sm" v-model="traslado.direccionPartida" placeholder="Dirección desde donde parten las mercancías" />
          </div>
          <div class="col-md-6">
            <label class="form-label small mb-1">Motivo del Traslado</label>
            <input type="text" class="form-control form-control-sm" v-model="traslado.motivo" placeholder="Ej: Traslado de mercancías por venta" />
          </div>
          <div class="col-md-6">
            <label class="form-label small mb-1">Ruta (opcional)</label>
            <input type="text" class="form-control form-control-sm" v-model="traslado.ruta" placeholder="Ruta de transporte" />
          </div>
        </div>
      </div>
    </div>

    <!-- DESTINATARIOS Y DETALLES -->
    <div class="card mb-4">
      <div class="card-header bg-success text-white fw-bold py-1 d-flex justify-content-between align-items-center">
        <span>Destinatarios y Mercancías</span>
        <button class="btn btn-light btn-sm" @click="agregarDestinatario">+ Agregar Destinatario</button>
      </div>
      <div class="card-body py-2">
        <div v-for="(dest, idx) in destinatarios" :key="idx" class="border rounded p-3 mb-3">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <h6 class="mb-0 text-success">Destinatario {{ idx + 1 }}</h6>
            <button v-if="destinatarios.length > 1" class="btn btn-outline-danger btn-sm" @click="eliminarDestinatario(idx)">🗑️ Eliminar</button>
          </div>
          <div class="row gy-2 mb-2">
            <div class="col-md-4">
              <label class="form-label small mb-1">Identificación</label>
              <input type="text" class="form-control form-control-sm" v-model="dest.identificacion" placeholder="RUC / Cédula" />
            </div>
            <div class="col-md-5">
              <label class="form-label small mb-1">Razón Social</label>
              <input type="text" class="form-control form-control-sm" v-model="dest.razonSocial" placeholder="Nombre del destinatario" />
            </div>
            <div class="col-md-3">
              <label class="form-label small mb-1">Motivo traslado destino</label>
              <input type="text" class="form-control form-control-sm" v-model="dest.motivoTraslado" placeholder="Motivo" />
            </div>
            <div class="col-12">
              <label class="form-label small mb-1">Dirección de Destino</label>
              <input type="text" class="form-control form-control-sm" v-model="dest.direccion" placeholder="Dirección del destinatario" />
            </div>
          </div>

          <!-- Detalles (productos) del destinatario -->
          <div class="table-responsive mb-2">
            <table class="table table-sm table-bordered mb-0">
              <thead class="table-light">
                <tr>
                  <th>Código</th>
                  <th style="min-width:200px">Descripción</th>
                  <th style="width:100px">Cantidad</th>
                  <th style="width:80px">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(det, dIdx) in dest.detalles" :key="dIdx">
                  <td><input type="text" class="form-control form-control-sm" v-model="det.codigo" placeholder="Código" /></td>
                  <td><input type="text" class="form-control form-control-sm" v-model="det.descripcion" placeholder="Descripción del bien" /></td>
                  <td><input type="number" class="form-control form-control-sm text-end" v-model.number="det.cantidad" min="0.01" step="0.01" /></td>
                  <td class="text-center"><button class="btn btn-outline-danger btn-sm" @click="eliminarDetalle(idx, dIdx)">🗑️</button></td>
                </tr>
                <tr v-if="dest.detalles.length === 0">
                  <td colspan="4" class="text-center text-muted small fst-italic">Sin detalles. Agrega al menos uno.</td>
                </tr>
              </tbody>
            </table>
          </div>
          <button class="btn btn-outline-success btn-sm" @click="agregarDetalle(idx)">+ Agregar ítem</button>
        </div>
      </div>
    </div>

    <!-- OBSERVACIONES -->
    <div class="card mb-4">
      <div class="card-header bg-success text-white fw-bold py-1">Observaciones</div>
      <div class="card-body py-2">
        <textarea class="form-control form-control-sm" rows="3" v-model="observaciones" placeholder="Observaciones adicionales (opcional)"></textarea>
      </div>
    </div>

    <!-- ACCIONES -->
    <div class="d-flex gap-2 justify-content-end">
      <router-link to="/ventas/documentos-emitidos" class="btn btn-outline-secondary">Cancelar</router-link>
      <button class="btn btn-outline-success" @click="guardar(false)" :disabled="procesando">
        <span v-if="procesando" class="spinner-border spinner-border-sm me-1"></span>
        Guardar Borrador
      </button>
      <button class="btn btn-success" @click="guardar(true)" :disabled="procesando">
        <span v-if="procesando" class="spinner-border spinner-border-sm me-1"></span>
        Emitir Guía
      </button>
    </div>

    <!-- ALERTA -->
    <div v-if="alerta.mensaje" :class="`alert alert-${alerta.tipo} mt-3`" role="alert">
      {{ alerta.mensaje }}
    </div>

  </div>
</template>

<script>
import api from '@/services/api'
import { mapGetters } from 'vuex'

function hoy() {
  const now = new Date()
  const ec = new Date(now.getTime() + -5 * 60 * 60 * 1000)
  return ec.toISOString().slice(0, 10)
}

export default {
  name: 'ClientGuiaRemision',

  data() {
    return {
      cabecera: {
        fechaEmision: hoy(),
        puntoEmisionId: '',
        ambiente: '',
      },
      secuencial: '000000001',
      puntosEmision: [],
      cargandoPuntos: false,

      transportista: {
        ruc: '',
        razonSocial: '',
        placa: '',
      },
      buscandoTransportista: false,

      traslado: {
        fechaInicio: hoy(),
        fechaFin: hoy(),
        direccionPartida: '',
        motivo: '',
        ruta: '',
      },

      destinatarios: [
        {
          identificacion: '',
          razonSocial: '',
          direccion: '',
          motivoTraslado: '',
          detalles: [{ codigo: '', descripcion: '', cantidad: 1 }],
        },
      ],

      observaciones: '',
      procesando: false,
      alerta: { mensaje: '', tipo: 'danger' },
    }
  },

  computed: {
    ...mapGetters(['currentUser']),
  },

  async mounted() {
    await this.cargarPuntosEmision()
    await this.cargarAmbiente()
  },

  methods: {
    async cargarPuntosEmision() {
      this.cargandoPuntos = true
      try {
        const { data } = await api.get('/configuracion/puntos-emision')
        this.puntosEmision = data.data || []
        if (this.puntosEmision.length > 0) {
          this.cabecera.puntoEmisionId = this.puntosEmision[0].id
        }
      } catch (e) {
        console.error('Error al cargar puntos de emisión:', e)
      } finally {
        this.cargandoPuntos = false
      }
    },

    async cargarAmbiente() {
      try {
        const { data } = await api.get('/configuracion/ambiente-sri')
        if (data.success && data.data) {
          this.cabecera.ambiente = data.data.nombre
        }
      } catch (e) {
        console.error('Error al cargar ambiente:', e)
      }
    },

    async buscarTransportista() {
      const ruc = this.transportista.ruc.trim()
      if (ruc.length < 10) return
      this.buscandoTransportista = true
      try {
        const { data } = await api.get(`/sri/ruc-catastro/${ruc}`)
        if (data.razon_social || data.nombre_comercial) {
          this.transportista.razonSocial = data.razon_social || data.nombre_comercial
        }
      } catch (e) {
        // Si no se encuentra, el usuario escribe manualmente
      } finally {
        this.buscandoTransportista = false
      }
    },

    agregarDestinatario() {
      this.destinatarios.push({
        identificacion: '',
        razonSocial: '',
        direccion: '',
        motivoTraslado: '',
        detalles: [{ codigo: '', descripcion: '', cantidad: 1 }],
      })
    },

    eliminarDestinatario(idx) {
      this.destinatarios.splice(idx, 1)
    },

    agregarDetalle(destIdx) {
      this.destinatarios[destIdx].detalles.push({ codigo: '', descripcion: '', cantidad: 1 })
    },

    eliminarDetalle(destIdx, detIdx) {
      this.destinatarios[destIdx].detalles.splice(detIdx, 1)
    },

    validar() {
      if (!this.cabecera.puntoEmisionId) return 'Seleccione un punto de emisión.'
      if (!this.transportista.ruc.trim()) return 'Ingrese el RUC del transportista.'
      if (!this.transportista.razonSocial.trim()) return 'Ingrese la razón social del transportista.'
      if (!this.transportista.placa.trim()) return 'Ingrese la placa del vehículo.'
      if (!this.traslado.direccionPartida.trim()) return 'Ingrese la dirección de partida.'
      if (!this.traslado.motivo.trim()) return 'Ingrese el motivo del traslado.'
      for (const dest of this.destinatarios) {
        if (!dest.razonSocial.trim()) return 'Complete la razón social de todos los destinatarios.'
        if (!dest.direccion.trim()) return 'Complete la dirección de todos los destinatarios.'
        if (dest.detalles.length === 0) return 'Cada destinatario debe tener al menos un detalle.'
        for (const det of dest.detalles) {
          if (!det.descripcion.trim()) return 'Complete la descripción de todos los detalles.'
          if (!det.cantidad || det.cantidad <= 0) return 'La cantidad debe ser mayor a 0.'
        }
      }
      return null
    },

    async guardar(emitir) {
      this.alerta = { mensaje: '', tipo: 'danger' }
      const error = this.validar()
      if (error) {
        this.alerta = { mensaje: error, tipo: 'warning' }
        return
      }

      this.procesando = true
      try {
        const payload = {
          intent: emitir ? 'ISSUE' : 'DRAFT',
          punto_emision_id: this.cabecera.puntoEmisionId,
          fecha_emision: this.cabecera.fechaEmision,
          ruc_transportista: this.transportista.ruc,
          razon_social_transportista: this.transportista.razonSocial,
          placa: this.transportista.placa,
          fecha_inicio_transporte: this.traslado.fechaInicio,
          fecha_fin_transporte: this.traslado.fechaFin,
          direccion_partida: this.traslado.direccionPartida,
          motivo_traslado: this.traslado.motivo,
          ruta: this.traslado.ruta || null,
          observaciones: this.observaciones || null,
          destinatarios: this.destinatarios.map(d => ({
            identificacion_destinatario: d.identificacion,
            razon_social_destinatario: d.razonSocial,
            direccion_destinatario: d.direccion,
            motivo_traslado: d.motivoTraslado || null,
            detalles: d.detalles.map(det => ({
              codigo_principal: det.codigo,
              descripcion: det.descripcion,
              cantidad: det.cantidad,
            })),
          })),
        }

        const { data } = await api.post('/guias-remision', payload)
        if (data.success) {
          this.alerta = { mensaje: emitir ? 'Guía emitida correctamente.' : 'Borrador guardado correctamente.', tipo: 'success' }
          setTimeout(() => this.$router.push('/ventas/documentos-emitidos'), 1500)
        } else {
          this.alerta = { mensaje: data.error || 'Error al procesar la guía.', tipo: 'danger' }
        }
      } catch (e) {
        this.alerta = { mensaje: e.response?.data?.error || 'Error al conectar con el servidor.', tipo: 'danger' }
      } finally {
        this.procesando = false
      }
    },
  },
}
</script>
